namespace $.$$ {
	export class $shm_hitalama_map_widget_float_settings_chart extends $.$shm_hitalama_map_widget_float_settings_chart {
		
		@ $mol_mem
		chart() {
			return this.controlled_widget().chart()!
		}

		@ $mol_mem
		table_head() {
			return this.chart().table_head()
		}

		axis( next?: string ){
			return this.chart().axis( next )
		}

		values( next?: ( any )[] ): readonly ( any )[] {
			return this.chart().values( next )
		}

		values_title( next?: string ) {
			return this.chart().values_title( next )
		}

		groups( next?: ( any )[] ): readonly ( any )[] {
			return this.chart().groups( next )
		}

		axis_details_visible() {
			return this.axis() == 'Дата' ? super.axis_details_visible() : []
		}

		@ $mol_mem
		axis_details( next?: string ): string {
			return this.chart().date_axis_details( this.axis(), next )
		}
		
	}
}
